import ProductCard from '@/components/ProductCard';
import Pagination from '@/components/TablePagination';
import { PaginationResult, ProductVariant, ShoppeProduct } from '@/types';

import NoResult from './NoResult';

type Variant = Pick<ProductVariant, 'color' | 'images'>;
type Product = Omit<ShoppeProduct<Variant>, 'code' | 'details'>;

const ProductGrid = ({ result }: { result: PaginationResult<Product> }) => {
  return result.total > 0 ? (
    <>
      {/* Tight columns, a little more between rows.

          Products sit closer together than cards do — the images are the grid,
          and wide gutters between them read as the shelf being half empty. Rows
          need slightly more than columns only because each product's price row
          would otherwise crowd the image of the one below it. */}
      <div className="grid grid-cols-2 gap-x-3 gap-y-6 sm:grid-cols-3 md:gap-x-4 lg:grid-cols-4 xl:grid-cols-5">
        {result.data.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
      <Pagination pageProp={result} />
    </>
  ) : (
    <NoResult kind="products" />
  );
};

export default ProductGrid;
